module.exports = __webpack_public_path__ + "img/train.be5030ca.webp";